import ace from 'ace-builds'

import './sf-liquid-highlight-rules'
import './sf-liquid-snippets'

ace.define('ace/mode/sf_liquid', [], function (require, exports, _module) {
  'use strict'

  const oop = require('ace/lib/oop')
  const LiquidMode = require('ace/mode/liquid').Mode
  const SfLiquidHighlightRules =
    require('ace/mode/sf_liquid_highlight_rules').SfLiquidHighlightRules
  const MatchingBraceOutdent =
    require('ace/mode/matching_brace_outdent').MatchingBraceOutdent
  const LiquidBehaviour = require('./behaviour/liquid').LiquidBehaviour
  const CstyleBehaviour = require('./behaviour/cstyle').CstyleBehaviour

  const SfLiquidBehaviour = function () {
    LiquidBehaviour.call(this)
    CstyleBehaviour.call(this)

    // when typing '{{', add ' }}'
    this.add(
      'braces',
      'insertion',
      function (state, action, editor, session, text) {
        if (text === '{') {
          const cursor = editor.getCursorPosition()
          const line = session.doc.getLine(cursor.row)
          const leftChar = line.substring(cursor.column, cursor.column - 1)

          if (leftChar !== '{') {
            return
          }

          return {
            text: '{  }}',
            selection: [2, 2],
          }
        }
      }
    )
  }
  oop.inherits(SfLiquidBehaviour, LiquidBehaviour)

  const Mode = function () {
    this.HighlightRules = SfLiquidHighlightRules
    this.$outdent = new MatchingBraceOutdent()
    this.$behaviour = new SfLiquidBehaviour()
  }
  oop.inherits(Mode, LiquidMode)
  ;(function () {
    this.$id = 'ace/mode/sf_liquid'
    this.snippetFileId = 'ace/snippets/sf_liquid'
  }.call(Mode.prototype))

  exports.Mode = Mode
})
